
























































































import mixins from 'vue-typed-mixins';
import { required ,  maxLength , email } from 'vuelidate/lib/validators';
import vuelidateMixin from "@/mixins/vuelidateMixin";
import {MetroVancouverGroupViewModel} from "@/models/MetroVancouverGroup";
import BoxContainer from "@/components/BoxContainer.vue";

export default mixins( vuelidateMixin ).extend ( {
  name: "MetroVanGroupForm" ,
  components: {BoxContainer} ,
  props: {
    value: {
      type: Object as () => MetroVancouverGroupViewModel
    },
    formSaving: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
    }
  } ,
  data(): {
    group: MetroVancouverGroupViewModel
    itemId: number
  }{
    return {
      group: { ...this.value } as MetroVancouverGroupViewModel,
      itemId: 0
    }
  },
  validations: {
    group: {
      adminSharedInbox: {
        required ,
        email ,
        maxLength: maxLength(100)
      },
      distributionList: {
        required ,
        email ,
        maxLength: maxLength(100)
      },
      limitedDistributionList: {
        email ,
        maxLength: maxLength(100)
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.group = { ...this.value }
      },
      deep: true ,
      immediate: true
    }
  },
  methods: {
    triggerValidation() {
      const valid = this.isValidWithNotification( this.$v.group );
      if ( valid ) {
        this.$emit('click');
      }
    }
  },
} )

